/** Top-level makeup studio menu — separate everyday presets, bridal looks, then customize. */

export const MAKEUP_V3_MENU_TABS = [
  { id: 'everyday', label: 'Everyday' },
  { id: 'bridal', label: 'Bridal' },
  { id: 'custom', label: 'Customize' },
];

export function isMakeupV3MenuTab(id) {
  return MAKEUP_V3_MENU_TABS.some((t) => t.id === id);
}
